import React from 'react'
import './Index.css'

const AboutUs = () => {
  return (
    <div  className='row'>
      <div style= {{padding:'0px', margin:'0px'}}>
      <h1  className = 'AboutEditText text-center pt-3 pb-3 '>ABOUT US</h1>
      </div>
      
      <div className = 'LinkContainer'>
      <div className = 'AboutEditText2 text-center'>WizWack is a completely safe and secure gaming platform. All the games on the platform are skill based and are totally fair. We partner with trusted payment partners to ensure safe and secure deposits and withdrawals. We have advanced systems in place to detect acts of fraudulent and we take quick and strict actions againt them, keeping WizWack a safe and fair platform. 
      <br /> <br /> 
      Download our game for android using the download button above.
      <br /> <br />
      </div>
      <div className='AboutEditText3 text-center'>
      Address: House No-42, Ground Floor, Block-B, Pkt-8, Sector-5, Rohini, New Delhi - 110085
      <br /> <br /> 
      <br /> <br /> 
      
      </div>
      </div>
    </div>
  )
}

export default AboutUs